export default __webpack_public_path__ + "static/media/mr_mrs_smith_grid_xl.c7324a3b.jpg";